app.service('AppointmentAPI', ['$http', 'ENV', 'Session', function($http, ENV, Session) {

	// Reminder settings are per user AND per practice, so the settings screen can edit
	// a practice other than the session one. Callers that omit it keep the old behaviour.
	function resolvePracticeId(practiceId) {
		return practiceId || (Session.practice && Session.practice.id);
	}

	var service = {
		isProcessing: false,

		// overridePracticeLeave books inside the practice's leave - the server only allows it for a Practice Admin.
		bookAppointment: function (data,_practiceId, overridePracticeLeave) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "POST",
				url: ENV.API + "/api/appointment" + (overridePracticeLeave ? "?overridePracticeLeave=true" : ""),
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				data,
			});
		},
		deleteAppointment: function (patientId, appointmentId,_practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "DELETE",
				url: ENV.API + `/api/appointment/patient/${patientId}/appointment/${appointmentId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		// One appointment, in the same shape as an entry of queryPatientAppointment's list, so a single
		// changed appointment can be refreshed without re-fetching the whole calendar range.
		getAppointment: function (patientId, appointmentId,_practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "GET",
				url: ENV.API + `/api/appointment/patient/${patientId}/appointment/${appointmentId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		updateAppointment: function (patientId, appointmentId, data,_practiceId, overridePracticeLeave) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "PUT",
				url: ENV.API + `/api/appointment/patient/${patientId}/appointment/${appointmentId}` + (overridePracticeLeave ? "?overridePracticeLeave=true" : ""),
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				data,
			});
		},
		queryPatientAppointment: function (clinicianId, start, endDateUTC,_practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: 'GET',
				url: ENV.API + `/api/appointment/practice?clinicianId=${clinicianId}&startDateUTC=${start}&endDateUTC=${endDateUTC}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		// Several practices' appointments in one request - the calendar's "All practices" view. Every practice
		// must be one the user belongs to; the signed-in practice goes in the header as for every other call.
		queryPracticesAppointments: function (clinicianId, start, endDateUTC, practiceIds) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/appointment/practices?practiceIds=${practiceIds.join(",")}&clinicianId=${clinicianId}&startDateUTC=${start}&endDateUTC=${endDateUTC}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		downloadAppointmentList: function (data,_practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "POST",
				url: ENV.API + '/api/appointment/practice/print',
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				responseType: "arraybuffer",
				data,
			});
		},
		downloadAppointmentListCsv: function (data, _practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: "POST",
				url: ENV.API + '/api/appointment/practice/csv',
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				responseType: "arraybuffer",
				data,
			});
		},
		getAppointmentUsers: function (practiceId){
			let id = practiceId ? practiceId : Session.practice.id;
			return $http({
				method: 'GET',
				url: ENV.API + `/api/users/appointment-users`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${id}`,
				},
			});
		},
		getAppointmentsForPatient: function (patientId) {
			return $http({
				method: 'GET',
				url: ENV.API + `/api/appointment/patient/${patientId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${Session.practice.id}`,
				},
			});
		},
		getAppointmentReminderSetting: function(userId, _practiceId) {
			return $http({
				method: 'GET',
				url: ENV.API + `/api/appointment-reminder/user/${userId}/settings`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
			});
		},
		updateAppointmentReminderSetting: function(userId,applyToAllUserPractices,data,_practiceId) {
			return $http({
				method: 'PUT',
				url: ENV.API + `/api/appointment-reminder/user/${userId}/settings?applyToAllUserPractices=${applyToAllUserPractices}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				data
			});
		},
		downloadFile: function(userId,name,categoryId,_practiceId) {
			return $http({
				method: "GET",
				url: ENV.API + `/api/appointment-reminder/user/${userId}/settings/file?fileName=${encodeURIComponent(name)}&categoryId=${categoryId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				responseType: "arraybuffer",
			});
		},
		deleteFile: function(userId,name,categoryId,_practiceId) {
			return $http({
				method: "DELETE",
				url: ENV.API + `/api/appointment-reminder/user/${userId}/settings/file?fileName=${encodeURIComponent(name)}&categoryId=${categoryId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
			});
		},
		uploadFile: function(userId,fileName,categoryId,blob,_practiceId) {
			const formData = new FormData();
			formData.append('fileName', fileName);
			formData.append('file', blob, fileName);

			return $http({
				method: 'POST',
				url: ENV.API + `/api/appointment-reminder/user/${userId}/settings/file?categoryId=${categoryId}`,
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': undefined,
                    "X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				data:formData,
				transformRequest: angular.identity
			})
		},
		// Sent as the appointment's own practice, like every other appointment call here: in the calendar's shared
		// "all practices" view an appointment can belong to a practice other than the one signed in to.
		sendReminder: function(appointmentId, patientId, _practiceId) {
			return $http({
				method: 'POST',
				url: ENV.API + `/api/appointment-reminder/patient/${patientId}/appointment/${appointmentId}`,
				headers: {
					'Authorization': 'Bearer ' + Session.token,
                    "X-PRACTICE-ID": `${resolvePracticeId(_practiceId)}`,
				},
				transformResponse: function (data, headersGetter) {
					return data;
				},
				responseType: "text",
			})
		},
		getReminderAudit: function(appointmentId, _practiceId) {
			let practiceId = _practiceId ? _practiceId : Session.practice.id;
			return $http({
				method: 'GET',
				url: ENV.API + `/api/appointment-reminder/${appointmentId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			});
		},
		getPracticeAvailability: function(practiceId, userId) {
			return $http({
				method: 'GET',
				url: ENV.API + `/api/appointment/practice/${practiceId}/user/${userId}/availability`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			})
		},
		addPracticeAvailability: function (practiceId, userId, data, applyToAllUserPractices) {
			return $http({
				method: 'POST',
				url: ENV.API + `/api/appointment/practice/${practiceId}/user/${userId}/availability?applyToAllUserPractices=${applyToAllUserPractices}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				data
			})
		},
		deletePracticeAvailability: function (practiceId, userId, availabilityId) {
			return $http({
				method: 'DELETE',
				url: ENV.API + `/api/appointment/practice/${practiceId}/user/${userId}/availability/${availabilityId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
			})
		},
		updatePracticeAvailability: function (practiceId, userId, availabilityId, data) {
			return $http({
				method: 'PUT',
				url: ENV.API + `/api/appointment/practice/${practiceId}/user/${userId}/availability/${availabilityId}`,
				headers: {
					Authorization: "Bearer " + Session.token,
					"X-PRACTICE-ID": `${practiceId}`,
				},
				data
			})
		},
	};

	return service;
}])
